<template>
  <div class="offline-page">
    <div class="page-head">
      <div>
        <h2>线下活动管理</h2>
        <p>创建扫码活动、配置现场商品，并完成自取核销。</p>
      </div>
      <el-button
        v-if="activeTab === 'activity'"
        type="primary"
        icon="el-icon-plus"
        @click="openActivity()"
        >新建活动</el-button
      >
    </div>

    <el-tabs v-model="activeTab" @tab-click="onTabChange">
      <el-tab-pane label="活动管理" name="activity">
        <div class="filters">
          <el-input v-model="activityQuery.name" clearable placeholder="搜索活动名称" />
          <el-select v-model="activityQuery.status" clearable placeholder="全部状态">
            <el-option label="启用" :value="1" /><el-option label="停用" :value="2" />
          </el-select>
          <el-button type="primary" @click="loadActivities">查询</el-button>
        </div>
        <el-table :data="activities" border v-loading="loading">
          <el-table-column prop="name" label="活动名称" min-width="180" />
          <el-table-column label="活动时间" min-width="280"
            ><template slot-scope="s"
              >{{ fmt(s.row.startTime) }} 至 {{ fmt(s.row.endTime) }}</template
            ></el-table-column
          >
          <el-table-column label="状态" width="100"
            ><template slot-scope="s"
              ><el-tag :type="s.row.status === 1 ? 'success' : 'info'">{{
                s.row.status === 1 ? "启用" : "停用"
              }}</el-tag></template
            ></el-table-column
          >
          <el-table-column label="操作" width="310" fixed="right"
            ><template slot-scope="s">
              <el-button type="text" @click="openActivity(s.row)">编辑</el-button>
              <el-button type="text" @click="toGoods(s.row)">配置商品</el-button>
              <el-button type="text" @click="showQr(s.row)">小程序码</el-button>
              <el-button type="text" @click="toOrders(s.row)">订单核销</el-button>
              <el-button type="text" class="danger" @click="removeActivity(s.row)">删除</el-button>
            </template></el-table-column
          >
        </el-table>
        <el-pagination
          class="pager"
          :current-page.sync="activityQuery.page"
          :page-size.sync="activityQuery.pageSize"
          :total="activityTotal"
          layout="total, sizes, prev, pager, next"
          @current-change="loadActivities"
          @size-change="loadActivities"
        />
      </el-tab-pane>

      <el-tab-pane label="活动商品" name="goods">
        <div class="filters">
          <el-select
            v-model="goodsQuery.activityId"
            filterable
            placeholder="请选择活动"
            @change="loadGoods"
            ><el-option v-for="a in activities" :key="a.id" :label="a.name" :value="a.id"
          /></el-select>
          <el-button
            type="primary"
            icon="el-icon-plus"
            :disabled="!goodsQuery.activityId"
            @click="selectorVisible = true"
            >绑定商品</el-button
          >
        </div>
        <el-table :data="goodsRows" border v-loading="loading">
          <el-table-column label="商品" min-width="260"
            ><template slot-scope="s"
              ><div class="goods-cell">
                <img :src="s.row.skuImage || s.row.mainGraph" />
                <div>
                  <b>{{ s.row.goodsName }}</b
                  ><span>{{ s.row.specsName || "默认规格" }}</span>
                </div>
              </div></template
            ></el-table-column
          >
          <el-table-column prop="originalPrice" label="原价" width="110" />
          <el-table-column prop="activityPrice" label="活动价" width="110" />
          <el-table-column label="活动数量" width="130"
            ><template slot-scope="s"
              >{{ s.row.soldStock || 0 }} / {{ s.row.activityStock }}</template
            ></el-table-column
          >
          <el-table-column label="状态" width="90"
            ><template slot-scope="s">{{
              s.row.status === 1 ? "启用" : "停用"
            }}</template></el-table-column
          >
          <el-table-column label="操作" width="130"
            ><template slot-scope="s"
              ><el-button type="text" @click="editBound(s.row)">编辑</el-button
              ><el-button type="text" class="danger" @click="removeGoods(s.row)"
                >移除</el-button
              ></template
            ></el-table-column
          >
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="订单核销" name="orders">
        <div class="filters">
          <el-select v-model="orderQuery.activityId" clearable filterable placeholder="全部活动"
            ><el-option v-for="a in activities" :key="a.id" :label="a.name" :value="a.id"
          /></el-select>
          <el-input v-model="orderQuery.keyword" clearable placeholder="订单号 / 领取码" />
          <el-select v-model="orderQuery.pickupStatus" clearable placeholder="全部领取状态"
            ><el-option label="未支付" :value="0"/><el-option label="待领取" :value="1"/><el-option
              label="已领取"
              :value="2"
          /></el-select>
          <el-button type="primary" @click="loadOrders">查询</el-button>
          <el-button icon="el-icon-s-check" @click="openPickup">输入领取码核销</el-button>
        </div>
        <el-table :data="orders" border v-loading="loading">
          <el-table-column prop="orderNo" label="订单号" min-width="200" />
          <el-table-column prop="userId" label="用户ID" width="100" />
          <el-table-column prop="phone" label="手机号" width="130" />
          <el-table-column prop="payAmount" label="实付" width="100" />
          <el-table-column prop="pickupCode" label="领取码" min-width="190" />
          <el-table-column label="领取状态" width="100"
            ><template slot-scope="s"
              ><el-tag
                :type="
                  s.row.pickupStatus === 2
                    ? 'success'
                    : s.row.pickupStatus === 1
                    ? 'warning'
                    : 'info'
                "
                >{{ pickupText(s.row.pickupStatus) }}</el-tag
              ></template
            ></el-table-column
          >
          <el-table-column label="操作" width="100"
            ><template slot-scope="s"
              ><el-button
                v-if="s.row.pickupStatus === 1"
                type="text"
                @click="confirmPickup(s.row.pickupCode)"
                >核销</el-button
              ></template
            ></el-table-column
          >
        </el-table>
        <el-pagination
          class="pager"
          :current-page.sync="orderQuery.page"
          :page-size.sync="orderQuery.pageSize"
          :total="orderTotal"
          layout="total, sizes, prev, pager, next"
          @current-change="loadOrders"
          @size-change="loadOrders"
        />
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :title="activityForm.id ? '编辑活动' : '新建活动'"
      :visible.sync="activityDialog"
      width="560px"
    >
      <el-form ref="activityForm" :model="activityForm" :rules="activityRules" label-width="90px">
        <el-form-item label="活动名称" prop="name"
          ><el-input v-model="activityForm.name" maxlength="100" show-word-limit
        /></el-form-item>
        <el-form-item label="活动时间" prop="range"
          ><el-date-picker
            v-model="activityForm.range"
            type="datetimerange"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width:100%"
        /></el-form-item>
        <el-form-item label="活动状态"
          ><el-radio-group v-model="activityForm.status"
            ><el-radio :label="1">启用</el-radio
            ><el-radio :label="2">停用</el-radio></el-radio-group
          ></el-form-item
        >
      </el-form>
      <span slot="footer"
        ><el-button @click="activityDialog = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="saveActivity">保存</el-button></span
      >
    </el-dialog>

    <SelectProductModal
      :visible.sync="selectorVisible"
      :selected-specs="[]"
      :multiple="true"
      @confirm="selectedProducts"
    />
    <el-dialog title="配置活动商品" :visible.sync="goodsDialog" width="760px">
      <el-table :data="selectedSpecs" border size="small">
        <el-table-column prop="goodsName" label="商品" min-width="180" show-overflow-tooltip />
        <el-table-column prop="specsName" label="规格" min-width="180" />
        <el-table-column prop="price" label="原价" width="90" />
        <el-table-column label="活动价" width="170"
          ><template slot-scope="s"
            ><el-input-number
              v-model="s.row.activityPrice"
              :min="0"
              :precision="2"
              :controls="false"/></template
        ></el-table-column>
        <el-table-column label="活动数量" width="170"
          ><template slot-scope="s"
            ><el-input-number
              v-model="s.row.activityStock"
              :min="s.row.soldStock || 0"
              :precision="0"/></template
        ></el-table-column>
      </el-table>
      <span slot="footer"
        ><el-button @click="goodsDialog = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="saveGoods">保存配置</el-button></span
      >
    </el-dialog>

    <el-dialog title="活动小程序码" :visible.sync="qrDialog" width="420px" center
      ><div class="qr-box">
        <img v-if="qrData" :src="qrData" />
        <p>用户扫码进入“{{ qrActivity.name }}”活动页</p>
        <el-button type="primary" plain @click="downloadQr">下载二维码</el-button>
      </div></el-dialog
    >
  </div>
</template>

<script>
import SelectProductModal from "@/views/seckill/SelectProductModal.vue";
import {
  getActivityList,
  editActivity,
  deleteActivity,
  getActivityGoods,
  editActivityGoods,
  deleteActivityGoods,
  getQrCode,
  getActivityOrders,
  pickupOrder
} from "@/api/offlineActivity";

export default {
  name: "OfflineActivityList",
  components: { SelectProductModal },
  data() {
    return {
      activeTab: "activity",
      loading: false,
      saving: false,
      activities: [],
      activityTotal: 0,
      activityQuery: { name: "", status: null, page: 1, pageSize: 15 },
      goodsQuery: { activityId: null, page: 1, pageSize: 50 },
      goodsRows: [],
      orderQuery: { activityId: null, pickupStatus: null, keyword: "", page: 1, pageSize: 15 },
      orders: [],
      orderTotal: 0,
      activityDialog: false,
      activityForm: { id: null, name: "", range: [], status: 1 },
      activityRules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        range: [
          { required: true, type: "array", min: 2, message: "请选择活动时间", trigger: "change" }
        ]
      },
      selectorVisible: false,
      goodsDialog: false,
      selectedSpecs: [],
      selectedGoodsId: null,
      qrDialog: false,
      qrData: "",
      qrActivity: {}
    };
  },
  created() {
    this.loadActivities();
  },
  methods: {
    fmt(v) {
      if (!v) return "-";
      return new Date(v).toLocaleString("zh-CN", { hour12: false });
    },
    pickupText(v) {
      return v === 2 ? "已领取" : v === 1 ? "待领取" : "未支付";
    },
    async loadActivities() {
      this.loading = true;
      try {
        const r = await getActivityList(this.activityQuery);
        this.activities = (r.data && r.data.entitys) || [];
        this.activityTotal = (r.data && r.data.totalCount) || 0;
      } finally {
        this.loading = false;
      }
    },
    onTabChange() {
      if (this.activeTab === "goods" && this.goodsQuery.activityId) this.loadGoods();
      if (this.activeTab === "orders") this.loadOrders();
    },
    openActivity(row) {
      this.activityForm = row
        ? { id: row.id, name: row.name, range: [row.startTime, row.endTime], status: row.status }
        : { id: null, name: "", range: [], status: 1 };
      this.activityDialog = true;
    },
    saveActivity() {
      this.$refs.activityForm.validate(async ok => {
        if (!ok) return;
        this.saving = true;
        try {
          const f = this.activityForm;
          const r = await editActivity({
            id: f.id || undefined,
            name: f.name,
            startTime: f.range[0],
            endTime: f.range[1],
            status: f.status
          });
          if (r.bizcode === 100) {
            this.$message.success("保存成功");
            this.activityDialog = false;
            await this.loadActivities();
          }
        } finally {
          this.saving = false;
        }
      });
    },
    removeActivity(row) {
      this.$confirm("删除后无法恢复，确认删除该活动？", "提示", { type: "warning" })
        .then(async () => {
          const r = await deleteActivity({ id: row.id });
          if (r.bizcode === 100) {
            this.$message.success("已删除");
            this.loadActivities();
          }
        })
        .catch(() => {});
    },
    toGoods(row) {
      this.goodsQuery.activityId = row.id;
      this.activeTab = "goods";
      this.loadGoods();
    },
    toOrders(row) {
      this.orderQuery.activityId = row.id;
      this.activeTab = "orders";
      this.loadOrders();
    },
    async loadGoods() {
      if (!this.goodsQuery.activityId) return;
      this.loading = true;
      try {
        const r = await getActivityGoods(this.goodsQuery);
        this.goodsRows = (r.data && r.data.entitys) || [];
      } finally {
        this.loading = false;
      }
    },
    selectedProducts(rows) {
      if (!rows || !rows.length) return;
      this.selectedGoodsId = null;
      this.selectedSpecs = rows.map(x => ({
        goodsId: x.goodsId,
        goodsName: x.goodsName,
        specsId: x.id,
        specsName: x.combNames,
        price: x.price,
        activityPrice: x.price,
        activityStock: 0,
        soldStock: 0,
        status: 1
      }));
      this.goodsDialog = true;
    },
    editBound(row) {
      this.selectedGoodsId = row.goodsId;
      this.selectedSpecs = [
        {
          goodsId: row.goodsId,
          goodsName: row.goodsName,
          specsId: row.specsId,
          specsName: row.specsName,
          price: row.originalPrice,
          activityPrice: row.activityPrice,
          activityStock: row.activityStock,
          soldStock: row.soldStock,
          status: row.status
        }
      ];
      this.goodsDialog = true;
    },
    async saveGoods() {
      if (
        this.selectedSpecs.some(
          x =>
            x.activityPrice === null ||
            x.activityPrice === undefined ||
            x.activityStock === null ||
            x.activityStock === undefined
        )
      ) {
        this.$message.warning("请填写活动价和活动数量");
        return;
      }
      this.saving = true;
      try {
        const groups = this.selectedSpecs.reduce((result, item) => {
          const goodsId = item.goodsId || this.selectedGoodsId;
          if (!result[goodsId]) result[goodsId] = [];
          result[goodsId].push(item);
          return result;
        }, {});
        const responses = await Promise.all(
          Object.keys(groups).map(goodsId =>
            editActivityGoods({
              activityId: this.goodsQuery.activityId,
              goodsId,
              specsJson: JSON.stringify(groups[goodsId])
            })
          )
        );
        if (responses.every(r => r.bizcode === 100)) {
          this.$message.success(`已保存 ${Object.keys(groups).length} 个商品的活动配置`);
          this.goodsDialog = false;
          this.loadGoods();
        }
      } finally {
        this.saving = false;
      }
    },
    removeGoods(row) {
      this.$confirm("确认移除这个活动规格？", "提示", { type: "warning" })
        .then(async () => {
          const r = await deleteActivityGoods({ id: row.id });
          if (r.bizcode === 100) this.loadGoods();
        })
        .catch(() => {});
    },
    async showQr(row) {
      this.qrActivity = row;
      const r = await getQrCode({ activityId: row.id });
      if (r.bizcode === 100) {
        this.qrData = r.data;
        this.qrDialog = true;
      }
    },
    downloadQr() {
      const a = document.createElement("a");
      a.href = this.qrData;
      a.download = (this.qrActivity.name || "线下活动") + "-二维码.png";
      a.click();
    },
    async loadOrders() {
      this.loading = true;
      try {
        const r = await getActivityOrders(this.orderQuery);
        this.orders = (r.data && r.data.entitys) || [];
        this.orderTotal = (r.data && r.data.totalCount) || 0;
      } finally {
        this.loading = false;
      }
    },
    openPickup() {
      this.$prompt("请输入用户出示的领取码", "订单核销", {
        confirmButtonText: "确认核销",
        inputPattern: /^\d{10,24}$/,
        inputErrorMessage: "请输入有效领取码"
      })
        .then(({ value }) => this.confirmPickup(value))
        .catch(() => {});
    },
    confirmPickup(code) {
      this.$confirm("核销后将确认收货并发放订单奖励，是否继续？", "确认核销", { type: "warning" })
        .then(async () => {
          const r = await pickupOrder({ pickupCode: code });
          if (r.bizcode === 100) {
            this.$message.success("核销成功");
            this.loadOrders();
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="scss">
.offline-page {
  padding: 24px;
  background: #fff;
  min-height: calc(100vh - 120px);
}
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}
.page-head h2 {
  margin: 0 0 8px;
  font-size: 22px;
}
.page-head p {
  margin: 0;
  color: #909399;
}
.filters {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 16px 0;
}
.filters .el-input,
.filters .el-select {
  width: 220px;
}
.pager {
  margin-top: 20px;
  text-align: right;
}
.danger {
  color: #f56c6c;
}
.goods-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}
.goods-cell img {
  width: 54px;
  height: 54px;
  object-fit: cover;
  border-radius: 6px;
}
.goods-cell b,
.goods-cell span {
  display: block;
}
.goods-cell span {
  margin-top: 5px;
  color: #909399;
}
.qr-box {
  text-align: center;
}
.qr-box img {
  display: block;
  width: 260px;
  height: 260px;
  margin: 0 auto 12px;
}
.qr-box p {
  color: #606266;
}
</style>
